import {useEffect} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {getTabTenantId, getTenants, setTenantId} from "utility/helpers/utils";

const useSyncTenantId = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const queryParams = new URLSearchParams(location?.search);
        const newTenantId = queryParams.get("tenantId");
        const tenants = JSON.parse(getTenants());
        const newTenant = tenants?.find((tenant) => tenant?.id === newTenantId);
        if (newTenant) {
            // Compared with this tab's entity, not the shared one: another tab may have changed that.
            if (newTenant && newTenantId && newTenantId !== getTabTenantId()) {
                setTenantId(newTenantId);
            }
        } else {
            if (location.search.includes(`tenantId=${newTenantId}`)) {
                history.push('/tenants')
            }
        }
    }, [location.search, history]);
};

export default useSyncTenantId;